<template>
  <PopupBase
    @close-pop-up="closePopUp"
    class="hydraulic-selector-disclaimer"
    v-bind="$attrs"
  >
    <div class="hydraulic-selector-disclaimer__content">
      <h3
        v-tv:hydraulicSelector="'disclaimerHeadline'"
      />
      <p v-text="mainText1" />
      <p v-text="mainText2" />
      <p v-text="mainText3" />
      <div class="hydraulic-selector-disclaimer__actions">
        <Checkbox
          :label="$tv('acceptDisclaimerLabel', 'hydraulicSelector')"
          :v-model="acceptedDisclaimer"
          @change="acceptedDisclaimer = !acceptedDisclaimer"
          :disabled="itemOnUpdate || bulkDeleteProcessing"
        />
        <ReactiveButton
          :button-text="$tv('accept', 'hydraulicSelector')"
          :disabled="disableButton"
          @click="closePopUp"
        />
      </div>
    </div>
  </PopupBase>
</template>

<script setup lang="ts">
import PopupBase from './PopupBase.vue'
import Checkbox from '~/components/input-components/Checkbox'
import ReactiveButton from '~/components/ReactiveButton'
import {useConfigurationDataStore} from '@/store/configuration-data'
import useI18nExtended from '~/composables/usei18nExtended'

const i18n = useI18nExtended()

const acceptedDisclaimer = ref(false)
const disableButton = computed(() => {
  return !acceptedDisclaimer.value
})

const mainText1 = computed(() => {
  return i18n.tv('disclaimerText1_1', 'hydraulicSelector') + ' '
    + i18n.tv('disclaimerText1_2', 'hydraulicSelector') + ' '
    + i18n.tv('disclaimerText1_3', 'hydraulicSelector') + ' '
    + i18n.tv('disclaimerText1_4', 'hydraulicSelector') + ' '
    + i18n.tv('disclaimerText1_5', 'hydraulicSelector') + ' '
    + i18n.tv('disclaimerText1_6', 'hydraulicSelector') + ' '
    + i18n.tv('disclaimerText1_7', 'hydraulicSelector') + ' '
})

const mainText2 = computed(() => {
  return i18n.tv('disclaimerText2_1', 'hydraulicSelector') + ' '
    + i18n.tv('disclaimerText2_2', 'hydraulicSelector') + ' '
})

const mainText3 = computed(() => {
  return i18n.tv('disclaimerText3', 'hydraulicSelector')
})

const closePopUp = () => {
  useConfigurationDataStore().acceptedHydraulicSelectorDisclaimer = acceptedDisclaimer.value
}

onMounted(() => {
})
</script>

<style lang="scss">
.hydraulic-selector-disclaimer {
  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;

    h3 {
      margin: 0;
    }
  }

  &__actions {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .popup > .popup__wrapper > .popup__content > .close {
    display: none;
  }
}

body:has(.hydraulic-selector-disclaimer.popup--visible) {
  overflow: hidden;
}
</style>
